// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"247":"32835fe2","872":"32835fe2","929":"01742100"}[chunkId] + ".css";
};